// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-gray {
  border: 1px rgba(0, 0, 0, 0.12) solid;
  border-radius: 8px;
  background-color: unset !important;
}

.mobile-container {
  height: calc(100vh - 197px);
  overflow-y: auto;
}

.mainWrap {
  background-color: #fff;
  color: #696b6e;
  position: relative;
  top: 0;
  padding: 0 61px 0 61px;
  height: calc(100vh - 250px);
  overflow-y: scroll;
}

.mobileFrame {
  margin: auto;
  width: 321px;
  border-radius: 20px;
  height: 655px;
  padding: 40px 10px 75px 10px;
  position: relative;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  border: 1px rgba(0, 0, 0, 0.12) solid;
}

.mobileSpaker {
  position: absolute;
  border-radius: 20px;
  background-color: #e0e0e0;
  top: 17px;
  left: 50%;
  height: 8px;
  width: 60px;
  transform: translate(-50%, 0px);
}

.mobileInner {
  border: solid 1px #e0e0e0;
  height: 538px;
  width: 301px;
  position: relative;
  z-index: 0;
  overflow: hidden;
}

.mobileButton {
  position: absolute;
  border-radius: 50%;
  border: solid 1px #e0e0e0;
  bottom: 17px;
  left: 50%;
  height: 50px;
  width: 50px;
  transform: translate(-50%, 0px);
}

.active {
  background-color: #1d7eaf;
  color: #fff;
}

button.mat-focus-indicator:focus {
  outline: none !important;
}

.mat-focus-indicator .mat-button-toggle-label-content {
  line-height: 48px !important;
}

.preview {
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  color: #333333;
}

.close {
  top: 0;
  right: 0;
  cursor: pointer;
}

::ng-deep .mat-button-toggle-appearance-standard .mat-button-toggle-label-content {
  line-height: 36px !important;
}

::ng-deep #desktop {
  margin-right: 2px;
}

.group {
  width: 100%;
  height: 55.92px;
  position: relative;
}

.rectangle1 {
  width: 100%;
  height: 100%;
  background: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 1px rgba(0, 0, 0, 0.12) solid;
}

.rectangle2 {
  width: 77.61px;
  height: 11.62px;
  left: 20.48px;
  top: 23.25px;
  position: absolute;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 100px;
}

.rectangle3 {
  width: 77.61px;
  height: 11.62px;
  left: 106.72px;
  top: 23.25px;
  position: absolute;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 100px;
}

.outer-space {
  padding-left: 12%;
  padding-right: 12%;
}`, "",{"version":3,"sources":["webpack://./src/app/views/angular-materials/shared-components/preview-template/preview-template.component.scss"],"names":[],"mappings":"AAAA;EACI,qCAAA;EACA,kBAAA;EACA,kCAAA;AACJ;;AAEA;EACI,2BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,4BAAA;EACA,kBAAA;EACA,2CAAA;EACA,gBAAA;EACA,qCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,+BAAA;AACJ;;AAEA;EACI,yBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;AACJ;;AAEA;EACI,yBAAA;EACA,WAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,4BAAA;AACJ;;AAEA;EACI,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,MAAA;EACA,QAAA;EACA,eAAA;AACJ;;AAEA;EACI,4BAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;EAEA,kBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4CAAA;AAAJ;;AAGA;EACI,cAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,kBAAA;AAAJ","sourcesContent":[".bg-gray {\r\n    border: 1px rgba(0, 0, 0, 0.12) solid;\r\n    border-radius: 8px;\r\n    background-color: unset !important;\r\n}\r\n\r\n.mobile-container {\r\n    height: calc(100vh - 197px);\r\n    overflow-y: auto;\r\n}\r\n\r\n.mainWrap {\r\n    background-color: #fff;\r\n    color: #696b6e;\r\n    position: relative;\r\n    top: 0;\r\n    padding: 0 61px 0 61px;\r\n    height: calc(100vh - 250px);\r\n    overflow-y: scroll;\r\n}\r\n\r\n.mobileFrame {\r\n    margin: auto;\r\n    width: 321px;\r\n    border-radius: 20px;\r\n    height: 655px;\r\n    padding: 40px 10px 75px 10px;\r\n    position: relative;\r\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\r\n    overflow: hidden;\r\n    border: 1px rgba(0, 0, 0, 0.12) solid;\r\n}\r\n\r\n.mobileSpaker {\r\n    position: absolute;\r\n    border-radius: 20px;\r\n    background-color: #e0e0e0;\r\n    top: 17px;\r\n    left: 50%;\r\n    height: 8px;\r\n    width: 60px;\r\n    transform: translate(-50%, 0px);\r\n}\r\n\r\n.mobileInner {\r\n    border: solid 1px #e0e0e0;\r\n    height: 538px;\r\n    width: 301px;\r\n    position: relative;\r\n    z-index: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n.mobileButton {\r\n    position: absolute;\r\n    border-radius: 50%;\r\n    border: solid 1px #e0e0e0;\r\n    bottom: 17px;\r\n    left: 50%;\r\n    height: 50px;\r\n    width: 50px;\r\n    transform: translate(-50%, 0px);\r\n}\r\n\r\n.active {\r\n    background-color: #1d7eaf;\r\n    color: #fff;\r\n}\r\n\r\nbutton.mat-focus-indicator:focus {\r\n    outline: none !important;\r\n}\r\n\r\n.mat-focus-indicator .mat-button-toggle-label-content {\r\n    line-height: 48px !important;\r\n}\r\n\r\n.preview {\r\n    font-family: \"Open Sans\", sans-serif;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n    text-align: left;\r\n    color: #333333;\r\n}\r\n\r\n.close {\r\n    top: 0;\r\n    right: 0;\r\n    cursor: pointer;\r\n}\r\n\r\n::ng-deep .mat-button-toggle-appearance-standard .mat-button-toggle-label-content {\r\n    line-height: 36px !important;\r\n}\r\n\r\n::ng-deep #desktop {\r\n    margin-right: 2px;\r\n}\r\n\r\n.group {\r\n    width: 100%;\r\n    height: 55.92px;\r\n    // border: 1px solid;\r\n    position: relative;\r\n}\r\n\r\n.rectangle1 {\r\n    width: 100%;\r\n    height: 100%;\r\n    background: white;\r\n    border-top-left-radius: 8px;\r\n    border-top-right-radius: 8px;\r\n    border-bottom: 1px rgba(0, 0, 0, 0.12) solid;\r\n}\r\n\r\n.rectangle2 {\r\n    width: 77.61px;\r\n    height: 11.62px;\r\n    left: 20.48px;\r\n    top: 23.25px;\r\n    position: absolute;\r\n    background: rgba(0, 0, 0, 0.12);\r\n    border-radius: 100px\r\n}\r\n\r\n.rectangle3 {\r\n    width: 77.61px;\r\n    height: 11.62px;\r\n    left: 106.72px;\r\n    top: 23.25px;\r\n    position: absolute;\r\n    background: rgba(0, 0, 0, 0.12);\r\n    border-radius: 100px\r\n}\r\n\r\n.outer-space{\r\n    padding-left: 12%;\r\n    padding-right: 12%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
